import * as angular from 'angular';
import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from 'rxjs';

import { Memo } from '../entities/memo.entity';
import { MemosFilters } from '../entities/memos-filters.entity';

@Injectable({ providedIn: 'root' })
export class MemoService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: MemoService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	// Methodes permettant le chargement des memos
	public getMemos(): Observable<Memo[]> {
		let url = this.path + 'memos';
		
		let result = this.httpClient //
			.get<Memo[]>(url) //
		;

		return result;
	}
	public getMemosByFilters(filters: MemosFilters): Observable<Memo[]> {
		let url = this.path + 'memos';
		
		let parameters = new HttpParams();
		for (let key in filters) {
			let value = (filters as any)[key];
			if (value != undefined) {
				parameters = parameters.set(key, value);
			}
		}
		let result = this.httpClient //
			.get<Memo[]>(url, { params: parameters }) //
		;

		return result;
	}
	
	// Methode permettant la sauvegarde d'un nouveau memo
	public createMemo(memo: Memo): Observable<Memo> {
		const url = this.path + 'memos';
		const request$ = this.httpClient.post<Memo>(url, memo, {});
		return request$;
	}
	
	// Methode permettant la sauvegarde d'une nouvelle version d'un memo deja existant
	public updateMemo(memo: Memo): Observable<Memo> {
		const url = this.path + 'memos';
		const request$ = this.httpClient.put<Memo>(url, memo, {});
		return request$;
	}
	
	// Methode permettant la suppression d'un memo
	public deleteMemo(memoId: number): Observable<any> {
		const url = this.path + 'memos/' + memoId;
		const request$ = this.httpClient.delete<any>(url, {});
		return request$;
	}
	
	// recherche les memos au niveau parc selon une date
	public getMemosOnParcForDate(parcId: number, date: string): Observable<Memo[]> {
		let url = this.path + 'memos/date/' + date + '/parc/' + parcId;
		return this.httpClient.get<Memo[]>(url, {});
	}
	
	// recherche les memos au niveau ouvrages selon une date
	public getMemosOnOuvragesForDate(ouvrageIds: string, date: string): Observable<Memo[]> {
		if (ouvrageIds.length) {
			let url = this.path + 'memos/date/' + date + '/ouvrages/' + ouvrageIds;
			return this.httpClient.get<Memo[]>(url, {});
		}
		return of([]);
	}
}

angular
	.module('auroraApp')
	.service('memoService', downgradeInjectable(MemoService));